import { CreateIdentityParameters } from './types';

export const validateCreateIdentityParams = (
  parameters: CreateIdentityParameters,
) => {
  const { externalToken } = parameters;

  if (!externalToken) {
    return new Error(
      'Missing one or more of the required properties: jwtToken',
    );
  }

  return undefined;
};
